module.exports = __webpack_public_path__ + "static/img/weixin.8bd8868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/weixin.png
// module id = eRyA
// module chunks = 1